module.exports = __webpack_public_path__ + "static/media/2000px-WhatsApp.svg_-1.c95a92a5.png";